import React from "react";
import "./CashFlowTable.scss";

const fmt = (val) =>
  Number(val ?? 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const sections = [
  {
    title: "RRJEDHA NGA AKTIVITETET OPERATIVE",
    rows: [
      { key: "netProfit", label: "Fitimi neto i periudhës" },
      {
        key: "changeReceivables",
        label: "Ndryshimi në llogaritë e arkëtueshme",
      },
      { key: "changeInventory", label: "Ndryshimi në stoqe" },
      {
        key: "changeOtherCurrentAssets",
        label: "Ndryshimi në pasuritë e tjera afatshkurtra",
      },
      { key: "changePayables", label: "Ndryshimi në llogaritë e pagueshme" },
      {
        key: "changeOtherCurrentLiabilities",
        label: "Ndryshimi në detyrimet e tjera afatshkurtra",
      },
      {
        key: "netOperating",
        label: "Neto rrjedha nga aktivitetet operative",
        isTotal: true,
      },
    ],
  },
  {
    title: "RRJEDHA NGA AKTIVITETET INVESTUESE",
    rows: [
      { key: "purchasePpe", label: "Investime në prona, pajisje dhe impiante" },
      { key: "purchaseIntangibles", label: "Investime në pasuri të paprekshme" },
      { key: "purchaseInvestmentProperty", label: "Investime në prona investuese" },
      {
        key: "purchaseFinancialInvestments",
        label: "Investime financiare dhe pjesëmarrje",
      },
      {
        key: "netInvesting",
        label: "Neto rrjedha nga aktivitetet investuese",
        isTotal: true,
      },
    ],
  },
  {
    title: "RRJEDHA NGA AKTIVITETET FINANCUESE",
    rows: [
      { key: "changeShortTermLoans", label: "Ndryshimi në kreditë afatshkurtra" },
      { key: "changeLongTermLoans", label: "Ndryshimi në kreditë afatgjata" },
      {
        key: "changeLeaseLiabilities",
        label: "Ndryshimi në detyrimet e lizingut",
      },
      { key: "changeOwnerCapital", label: "Ndryshimi në kapitalin e pronarit" },
      { key: "changeReserves", label: "Ndryshimi në rezerva" },
      {
        key: "changeRetainedEarnings",
        label: "Ndryshimi në fitimin e bartur",
      },
      {
        key: "changeBankOverdraft",
        label: "Ndryshimi në mbitërheqjen bankare",
      },
      {
        key: "reconciliationAdjustment",
        label: "Rregullim për barazim me ndryshimin e parasë",
      },
      {
        key: "netFinancing",
        label: "Neto rrjedha nga aktivitetet financuese",
        isTotal: true,
      },
    ],
  },
  {
    title: "PARAJA DHE EKUIVALENTËT",
    rows: [
      { key: "openingCash", label: "Paraja në fillim të periudhës" },
      {
        key: "netCashMovement",
        label: "Rritja / (ulja) neto e parasë gjatë periudhës",
        isTotal: true,
      },
      {
        key: "closingCash",
        label: "Paraja në fund të periudhës",
        isTotal: true,
      },
    ],
  },
];

function LoadingRows() {
  return (
    <div className="CF__Table__Loading">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="CF__Table__LoadingCard" />
      ))}
    </div>
  );
}

export default function CashFlowTable({ currentFlow, priorFlow, fiscalYear, loading }) {
  if (loading) {
    return <LoadingRows />;
  }

  const current = currentFlow ?? {};
  const prior = priorFlow ?? {};
  const priorYear = Number(fiscalYear) - 1;

  return (
    <div className="CF__Table__Card">
      <div className="CF__Table__DesktopHeader">
        <div className="CF__Table__DH__Description">Përshkrimi</div>
        <div className="CF__Table__DH__Amount">Më 31.12.{fiscalYear}</div>
        <div className="CF__Table__DH__Amount">Më 31.12.{priorYear}</div>
      </div>

      <div className="CF__Table__Sections">
        {sections.map((section) => (
          <div key={section.title} className="CF__Table__Section">
            <div className="CF__Table__SectionHeader">
              <h3>{section.title}</h3>
            </div>

            <div className="CF__Table__Rows">
              {section.rows.map((row) => (
                <div
                  key={row.key}
                  className={[
                    "CF__Table__Row",
                    row.isTotal ? "CF__Table__Row--total" : "CF__Table__Row--default",
                  ].join(" ")}
                >
                  <div className="CF__Table__DescriptionWrap">
                    <span className="CF__Table__Label">{row.label}</span>
                  </div>

                  <div className="CF__Table__AmountCell">
                    <span className="CF__Table__AmountLabel">Aktual</span>
                    <span className="CF__Table__AmountValue">{fmt(current[row.key])}</span>
                  </div>

                  <div className="CF__Table__AmountCell CF__Table__AmountCell--prior">
                    <span className="CF__Table__AmountLabel">Paraprak</span>
                    <span className="CF__Table__AmountValue">{fmt(prior[row.key])}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
